"use client";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/shared/ui/accordion";
import { type FaqListItem } from "@/server-action/customer-service/get-faq-list";
import { useTranslations } from "next-intl";

interface FaqContentProps {
  faqs: FaqListItem[];
}

export function FaqContent({ faqs }: FaqContentProps) {
  const t = useTranslations();

  if (faqs.length === 0) {
    return (
      <div className="bg-secondary-100 tb:h-[480px] flex h-[222px] flex-col items-center justify-center rounded-[16px] py-25">
        <div className="body-md-regular text-gray-400">{t("f_fq_list_null")}</div>
      </div>
    );
  }

  return (
    <Accordion type="single" collapsible className="tb:space-y-3 pc:space-y-4 w-full space-y-2">
      {faqs.map((item) => (
        <AccordionItem value={`item-${item.id}`} className="border-b-0" key={item.id}>
          <AccordionTrigger className="bg-secondary-100 tb:px-6 tb:py-0 tb:h-22 flex h-auto items-center rounded-2xl px-4 py-4 data-[state=open]:rounded-b-none">
            <div className="tb:h-auto flex h-full items-center">
              <div className="tb:h-auto h-full">
                <span className="bg-secondary-200 body-lg-bold tb:size-10 tb:mr-4 mr-3 flex size-7.5 flex-shrink-0 items-center justify-center rounded-full text-gray-900">
                  Q
                </span>
              </div>
              <span className="body-lg-bold text-gray-900">{item.question}</span>
            </div>
          </AccordionTrigger>
          <AccordionContent className="body-md-regular bg-secondary-100 tb:p-6 flex flex-col rounded-b-2xl px-5 pt-1 pb-4 text-balance text-gray-700">
            <p className="break-words whitespace-pre-line">{item.answer}</p>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
